<template>
	<div>
		<app-app-header :title="$t('label.community')"
						v-model="indexStore.isHeaderVisible"
						:color="$config.public.colors.community"
						flat-on-top
						hide-on-scroll/>

		<app-content>
			<page-content background xs-full sm-full>
				<container xs-full sm-full class="stretch-layout" tight>
					<card xs-tile sm-tile class="flex-grow-1">
						<card-text class="p-0" fill>
							<activity-feed id="newsfeed" :url="`/v1/views/community`" flat only-auth-creator with-ads class="mb-64 md:mb-0"/>
						</card-text>
					</card>
				</container>
			</page-content>
		</app-content>
	</div>
</template>

<script setup lang="ts">

import {useIndexStore} from "../store";

const {t} = useI18n();
const indexStore = useIndexStore();

useMeta({
	title: t('view.community.title'),
	description: t('view.community.description')
})

</script>

